export const DATETIME_FORMAT = {
  standardDayFormat: 'YYYY-MM-DD',
  standardFullDateTimeFormat: 'YYYY-MM-DD HH:mm',
} as const
